import { useState } from "react";
import { FileDown, CheckCircle2, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

export const LeadMagnet = () => {
  const [form, setForm] = useState({ name: "", email: "", company: "" });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading"); setError("");
    try {
      await api.post("/lead-magnet", form);
      setStatus("done");
      window.open(`${process.env.REACT_APP_BACKEND_URL}/api/lead-magnet/download`, "_blank");
    } catch {
      setStatus("idle");
      setError("Une erreur est survenue. Vérifiez votre email et réessayez.");
    }
  };

  return (
    <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-24 md:pb-32" data-testid="lead-magnet-section">
      <Reveal>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0" style={{ border: "1px solid var(--border)" }}>
          <div className="lg:col-span-7 p-8 md:p-14" style={{ background: "var(--ink)", color: "var(--bone)" }}>
            <p className="overline mb-3" style={{ color: "var(--orange)" }}>Livre blanc · Édition 2026</p>
            <h2 className="font-display font-black text-3xl md:text-5xl tracking-tight leading-none">
              Faire de la prévention un levier de performance.
            </h2>
            <p className="mt-6 text-lg max-w-xl" style={{ color: "rgba(245,245,240,0.75)" }}>
              Le guide de référence des dirigeants et responsables HSE : les 6 chantiers prioritaires, un plan d'action 90 jours et les chiffres clés pour convaincre votre direction.
            </p>
            <ul className="mt-6 space-y-2">
              {["Les 5 chantiers d'une démarche QSE efficace", "Réduire TMS et absentéisme par l'ergonomie", "Checklist conformité & ISO 45001", "Plan d'action 90 jours prêt à déployer"].map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm" style={{ color: "rgba(245,245,240,0.85)" }}>
                  <CheckCircle2 size={16} style={{ color: "var(--orange)" }} /> {p}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-5 p-8 md:p-14 flex flex-col justify-center" style={{ background: "var(--white)" }}>
            {status === "done" ? (
              <div data-testid="lead-magnet-success">
                <CheckCircle2 size={40} style={{ color: "var(--orange)" }} />
                <h3 className="font-display font-bold text-2xl mt-5 mb-3">Votre guide est en route !</h3>
                <p style={{ color: "var(--ink-2)" }}>
                  Le téléchargement a démarré et un exemplaire vient de vous être envoyé par email.
                </p>
                <a href={`${process.env.REACT_APP_BACKEND_URL}/api/lead-magnet/download`} target="_blank" rel="noreferrer"
                  className="btn-primary mt-6 px-6 py-3.5 font-semibold inline-flex items-center gap-2" data-testid="lead-magnet-redownload">
                  <FileDown size={17} /> Re-télécharger le PDF
                </a>
              </div>
            ) : (
              <form onSubmit={submit} data-testid="lead-magnet-form">
                <h3 className="font-display font-bold text-2xl mb-1">Recevez le guide gratuit</h3>
                <p className="text-sm mb-6" style={{ color: "var(--ink-2)" }}>PDF · 7 pages · sans engagement</p>
                <div className="space-y-4">
                  <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                    placeholder="Votre nom *" data-testid="lead-magnet-name"
                    className="w-full px-4 py-3.5 outline-none" style={{ border: "1px solid var(--border)", background: "var(--bone)" }} />
                  <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                    placeholder="Email professionnel *" data-testid="lead-magnet-email"
                    className="w-full px-4 py-3.5 outline-none" style={{ border: "1px solid var(--border)", background: "var(--bone)" }} />
                  <input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })}
                    placeholder="Entreprise" data-testid="lead-magnet-company"
                    className="w-full px-4 py-3.5 outline-none" style={{ border: "1px solid var(--border)", background: "var(--bone)" }} />
                </div>
                {error && <p className="mt-3 text-sm" style={{ color: "#C23B22" }} data-testid="lead-magnet-error">{error}</p>}
                <button type="submit" disabled={status === "loading"} data-testid="lead-magnet-submit"
                  className="btn-primary mt-6 w-full px-6 py-4 font-semibold inline-flex items-center justify-center gap-2">
                  {status === "loading" ? "Envoi en cours…" : <>Télécharger le guide <ArrowRight size={17} /></>}
                </button>
                <p className="mt-3 text-xs" style={{ color: "var(--ink-2)" }}>
                  En téléchargeant ce guide, vous acceptez d'être recontacté par nos équipes. Pas de spam, promis.
                </p>
              </form>
            )}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
